import { render, staticRenderFns } from "./LiteratureContent.vue?vue&type=template&id=5b4b9f13&scoped=true"
import script from "./LiteratureContent.vue?vue&type=script&lang=js"
export * from "./LiteratureContent.vue?vue&type=script&lang=js"
import style0 from "./LiteratureContent.vue?vue&type=style&index=0&id=5b4b9f13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4b9f13",
  null
  
)

export default component.exports